import Vue from 'vue'
import Vuex from 'vuex'
import apiClient from '@v/apiClient.js'
import * as customFields from '@v/settings/application/custom-fields/CustomFieldsModule.js'
import * as visitorClassifications from '@v/settings/application/visitorclassifications/VisitorClassificationsModule.js'
import * as integrations from '@v/settings/application/integrations/IntegrationsModule.js'
import * as notification from '@v/store/notificationsModule.js'
import * as imagePicker from '@v/store/imagePickerModule.js'
import * as user from '@v/store/userModule.js'
import bookingDetails from '@/vue/bookings/details/bookingDetailsModule.js'
import * as bookings from '@/vue/bookings/bookingsModule.js'
import briqStateModule from '@v/store/briqStateModule.js'
import businessUitBillingModule from '@/vue/settings/application/billing/BusinessUnitBillingModule.js'
import * as inventory from '@/vue/inventory/inventoryModule.js'
import * as dataCultures from '@/vue/reports/dataCulturesModule.js'
import bookingUpsert from '@v/bookings/edit/BookingUpsertModule.js'
import planboardModule from '@/vue/planboard/planboardModule.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    customFields,
    visitorClassifications,
    integrations,
    notification,
    imagePicker,
    user,
    briqState: briqStateModule,
    bookings,
    bookingDetails: bookingDetails(apiClient),
    bookingUpsert: bookingUpsert(apiClient),
    businessUnitBillingData: businessUitBillingModule(apiClient),
    inventory,
    planboardModule: planboardModule(apiClient),
    dataCultures,
  },
})

store.dispatch('briqState/maybeFetchBriqState')

export default store
